import React from 'react';
import { VideoFeatures } from '@/store/videoFeatures';
import { VideoControlsOriginal } from './VideoControlsOriginal';

interface VideoControlsConfiguratorProps {
  features: VideoFeatures;
  setFeature: <K extends keyof VideoFeatures>(key: K, value: VideoFeatures[K]) => void;
}

export const VideoControlsConfigurator: React.FC<VideoControlsConfiguratorProps> = ({
  features,
  setFeature,
}) => {
  return (
    <VideoControlsOriginal features={features} setFeature={setFeature} />
  );
};